/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;



//////////////////
// WEBPACK FOOTER
// /opt/build/repo/node_modules/lodash/_listCacheClear.js
// module id = 782
// module chunks = 0 1 2 3 4 5 6 7 8